import { $_app_server } from '@/_helpers'

export const dialogMessageService = {
  saveMessage,
  readMessage,
  list,
  excel,
  checkUnreadMessage
}
let func = (response) => response.data

function saveMessage(params) {
  return $_app_server.post(`dialogMessage/save`, null, { params: params }).then(func)
}

function readMessage(messageId) {
  return $_app_server.put(`dialogMessage/readMessage/${messageId}`).then(func)
}

function list(id, params) {
  return $_app_server.get(`dialogMessage/list/${id}`, {
    params: params
  }).then(func)
}

function excel(id, params) {
  return $_app_server.get(`dialogMessage/excel/${id}`, {
    responseType: 'blob',
    params: params
  })
}

function checkUnreadMessage() {
  return $_app_server.get(`dialogMessage/hasUnreadMessage`).then(func)
}